export default __webpack_public_path__ + "static/media/hamburger.211dc80a.svg";